import React from 'react'
import { Colors } from '../../themes';

export const RequireForm = () => (<span style={{ color: Colors.error }}>* </span>);
